import { NotificationType, notify } from 'src/providers/NotificationProvider'

import { ButtonRebrand } from 'src/components/atoms/ButtonRebrand'
import { Heading3, Heading5, Paragraph } from 'src/components/atoms/Typography'
import { HStack } from 'src/components/templates/HStack'

import {
  namedOperations,
  useUpdateGiftTemplateMutation
} from 'src/config/generated/graphql'

export interface UnarchiveGiftTemplateModalProps {
  id?: string
  title?: string
  closeModal: () => void
}

export const UnarchiveGiftTemplateModal = ({
  id,
  title,
  closeModal
}: UnarchiveGiftTemplateModalProps) => {
  const [updateGiftTemplate] = useUpdateGiftTemplateMutation({
    refetchQueries: [namedOperations.Query.listAdminGiftTemplates]
  })

  const handleUnarchive = async () => {
    if (!id) return

    try {
      await updateGiftTemplate({
        variables: { input: { Id: id, IsAvailable: true } }
      })
      notify({
        message: 'Certificate unarchived',
        type: NotificationType.success
      })
      closeModal()
    } catch {
      notify({
        message: 'Could not unarchive the certificate',
        type: NotificationType.error
      })
    }
  }

  return (
    <div className='w-full sm:w-[520px]'>
      <Heading3>Unarchive certificate</Heading3>
      {title ? <Heading5>{title}</Heading5> : null}
      <Paragraph>
        Are you sure you want to unarchive this certificate? It will be
        available to select for bulk gifts again.
      </Paragraph>
      <HStack className='mt-10 flex justify-between'>
        <ButtonRebrand variant='outline' onClick={closeModal}>
          Cancel
        </ButtonRebrand>
        <ButtonRebrand variant='lime' onClick={handleUnarchive}>
          Yes, unarchive
        </ButtonRebrand>
      </HStack>
    </div>
  )
}
